import api from '../api'

export default {
  update(body) {
    return api.put('/partner-licensings/:partnerLicensingId/settings/address', body)
  },
}
